module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Log Out":"Log Out","user":"user","Copy UserId":"Copy UserId","UserId copied successfully":"UserId copied successfully"},"zh":{"Log Out":"退出登录","user":"用户","Copy UserId":"复制用户ID","UserId copied successfully":"用户ID复制成功"}}')
  delete Component.options._Ctor
}
